import * as actionTypes from "./actionTypes";
import * as actions from './index';


export const updateEcommerceObjectsSuccess = (data) => {
    return {
        type: actionTypes.ECOMMERCE_UPDATE_ECOMMERCEOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateEcommerceObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateEcommerceObjectsSuccess(obj));
    }
}

export const setInitShareObjects = () => {
    return {
        type: actionTypes.ECOMMERCE_SET_INIT_ECOMMERCEOBJECTS
    }
}

export const getList = async ({ list, itemlist }) => {
    let newList = [];
    for (let i = 0; i < list.length; i++) {
        let found;
        let li = list[i];
        let tmp;
        if (itemlist && itemlist.length) found = itemlist.find(entry => entry.id == li.spots_id)
        if (found && found.data && found.data.metadata) tmp = found;
        else {
            try {
                const res = await window.flow.sdkGetItem(li.spots_id);
                tmp = res;
            } catch (err) { console.log("LOGS: getList err", err) }
        }
        if (tmp && tmp.data) {
            let nShows = [];
            if (li.shows) {
                try {
                    nShows = JSON.parse(li.shows);
                } catch (err) { console.log("LOGS: getList err", err) }
            }

            newList.push({
                metadata: { fields: { ...tmp.data.metadata.fields } }, ...li,
                id: tmp.data.id, rentelid: li.id, shows: nShows
            });
        }
    }
    return newList;
}

export const getShowDates = ({ newCartList }) => {
    let itemsShowsObj = {};
    if (newCartList && newCartList.length) {
        newCartList.forEach(item => {
            itemsShowsObj[item.id] = {};
            if (item.showdates && item.showdates.length) {
                item.showdates.forEach((date, idx) => {
                    itemsShowsObj[item.id][date] = item.shows[idx] || 1;
                })
            }
        })
    }
    return { itemsShowsObj };
}


export const searchGetFeRents = ({ rentid, limit = 15, offset = 3 }) => {
    let searchObj = {};
    if (rentid) searchObj = { fields: { rentid }, limit, offset };

    return async (dispatch, getState) => {
        try {
            dispatch(actions.updateEcommerceObjects({ loading: true }));
            console.log("LOGS: sdkVlSearchRents");
            const res = await window.flow.sdkVlSearchRents(searchObj);
            if (res) {
                console.log("LOGS: searchGetFeRents res", res);
                if (res && res.data && res.data.length) {
                    let rentList = [];
                    let itemList = [];
                    for (let i = 0; i < res.data.length; i++) {
                        let elem = res.data[i];
                        let userRes = await window.flow.crmSearchUsers({ 'users.id': elem.sdkusers_id });
                        let user;
                        if (userRes && userRes.data) user = userRes.data[0];
                        let newElem = { ...elem, user, data: [] };
                        if (elem && elem.rentels) {
                            let list = elem.rentels;
                            if (list && list.length) {
                                let newList = await getList({ list, itemList });
                                if (newList) newElem.data = newList;
                            }
                        }
                        rentList.push(newElem);
                    }
                    console.log("LOGS: LAMTEST searchFeRents rentList", rentList);
                    if (rentList && rentList.length) {
                        dispatch(actions.updateEcommerceObjects({ rentList: rentList, loading: false }));
                    }
                }
            }
            dispatch(actions.updateEcommerceObjects({ loading: false }));
        } catch (err) {
            console.log("LOGS: searchFeRents err", err);
            dispatch(actions.updateEcommerceObjects({ loading: false }));
        }
    }
}


export const getFeRent = ({ rentid }) => {

    return async (dispatch, getState) => {
        try {
            dispatch(actions.updateEcommerceObjects({ loading: true }));
            let res;
            if (rentid) {
                console.log("LOGS: sdkVlGetRent rentid", rentid);
                res = await window.flow.sdkVlGetRent(rentid);
                if (res && res.data && res.data.rent) {
                    let parsedrentels = [];
                    if (res.data.rent.rentels && res.data.rent.rentels.length) {
                        parsedrentels = res.data.rent.parsedrentels.map(el => {
                            return { ...el, item: { metadata: { fields: { ...el.item } } } }
                        })
                    }
                    dispatch(actions.updateEcommerceObjects({ currentRent: { ...res.data.rent, parsedrentels }, loading: false }));
                }
            }
            if (res) {
                console.log("LOGS: sdkVlGetRent res", res);
            }
            dispatch(actions.updateEcommerceObjects({ loading: false }));
        } catch (err) {
            console.log("LOGS:sdkVlGetRent err", err);
            dispatch(actions.updateEcommerceObjects({ loading: false }));
        }
    }
}

